import Availability from 'modules/common/availability/availability';
import React from 'react';
import { ShortcutLeadingCell } from './shortcutLeadingCell';
import { Shortcut, ShortcutAction } from 'modules/shortcuts/models';
import { MoreShortcutOptions } from './moreShortcutOptions';
import CollapsableTableRow from 'modules/common/components/collapsibleTableRow/collapsibleTableRow';
import { useSelector } from 'react-redux';
import { GlobalApplicationState } from 'globalApplicationState';
import ChipList from 'modules/common/components/chipList';
import { ICollapsibleTableCellElement } from 'modules/common/models';
import { MAX_URL_LENGTH } from 'modules/shortcuts/styles/constants';

interface IShortcutRow {
    shortcut: Shortcut;
    selected: boolean;
    expanded: boolean;
    rowRefs?: React.MutableRefObject<Record<string, HTMLTableRowElement | null>>;
    onSelectShortcut: (selected: boolean, shortcut: Shortcut) => void;
    onShortcutAction: (shortcut: Shortcut, shortcutAction: ShortcutAction) => void;
}

export const ShortcutRow: React.FC<IShortcutRow> = ({
    shortcut,
    selected,
    expanded,
    rowRefs,
    onSelectShortcut,
    onShortcutAction
}) => {
    const audiences = useSelector((state: GlobalApplicationState) => state.audiences.audiences);

    const shortcutRowContent: ICollapsibleTableCellElement[] = [
        { element: undefined },
        {
            element: <ShortcutLeadingCell
                shortcut={shortcut}
                selected={selected}
                onSelectShortcut={onSelectShortcut}
                onEditShortcut={s => onShortcutAction(s, ShortcutAction.EDIT)}
            />,
            tableCellProps: {
                align: "left",
                padding: "none"
            }
        },
        {
            element: <MoreShortcutOptions 
                enabled={shortcut.isEnabled}
                onShortcutAction={a => onShortcutAction(shortcut, a)}
            />
        },
        {
            element: <Availability isDisabled={!shortcut.isEnabled} />,
            tableCellProps: {
                align: "center",
                padding: "normal"
            },
            tableCellClassName: "shortcuts-availability-cell"
        },
        {
            element: <div className="shortcuts-audience-chip-list">
                <ChipList
                    items={shortcut.audiences.map(aId => ({
                        id: aId,
                        name: audiences.find(aud => aud.id === aId)?.displayName ?? "Unknown"
                    }))}
                    truncateAtIndex={1}
                    emptyChipDetails={{
                        show: true,
                        contents: "All users"
                    }}
                />
            </div>,
            tableCellProps: {
                align: "center",
                padding: "normal",
            },
            tableCellClassName: "shortcut-audience-cell"
        },
        {
            element: shortcut.url.length > MAX_URL_LENGTH ? shortcut.url.slice(0, MAX_URL_LENGTH - 3) + "..." : shortcut.url,
            tableCellProps: {
                align: "center",
                padding: "normal"
            }
        },
        {
            element: shortcut.openInNewWindow ? "New window" : "Same window",
            tableCellProps: {
                align: "center",
                padding: "normal"
            }
        }
    ]

    return <CollapsableTableRow 
        hover 
        expanded={expanded} 
        tableCellElements={shortcutRowContent} 
        rowKey={shortcut.id}
        rowRefs={rowRefs}
    />;
};